import type { RumInitConfiguration } from "@datadog/browser-rum";

export const LOGIN_DATADOG_CONFIG: Omit<RumInitConfiguration, "clientToken"> = {
  applicationId: "bef38399-2a1c-4acd-9ae4-97960e9f7de4",
  site: "datadoghq.com",
  service: "front-login",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
};

export const ACCOUNT_DATADOG_CONFIG: Omit<RumInitConfiguration, "clientToken"> = {
  applicationId: "6f2ae17b-4777-494d-9f84-cd37ff4e3090",
  site: "datadoghq.com",
  service: "front-account",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
};
